export const fmt = (n, d = 2) =>
  n === null || n === undefined ? "—" : Number(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });

export const money = (n) => `$${fmt(n)}`;

export const PnL = ({ value, prefix = "$", testId }) => (
  <span data-testid={testId} className={`tabular ${value >= 0 ? "text-[#00E676]" : "text-[#FF3B30]"}`}>
    {value >= 0 ? "+" : "-"}{prefix}{fmt(Math.abs(value))}
  </span>
);

export const StatCard = ({ label, value, sub, accent, testId, delay = 0 }) => (
  <div className="card-dark card-dark-hover p-5 fade-up" style={{ animationDelay: `${delay}ms` }} data-testid={testId}>
    <p className="label-xs">{label}</p>
    <p className={`tabular text-xl sm:text-2xl mt-2 ${accent || "text-white"}`}>{value}</p>
    {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
  </div>
);

export const StatusBadge = ({ status }) => {
  const map = {
    connected: "text-[#00E676] bg-[#00E676]/10", active: "text-[#00E676] bg-[#00E676]/10",
    approved: "text-[#00E676] bg-[#00E676]/10", paid: "text-[#00E676] bg-[#00E676]/10",
    signed: "text-[#00E676] bg-[#00E676]/10", answered: "text-[#00F0FF] bg-[#00F0FF]/10",
    open: "text-[#FFD600] bg-[#FFD600]/10", pending: "text-[#FFD600] bg-[#FFD600]/10",
    paused: "text-[#FFD600] bg-[#FFD600]/10", overdue: "text-[#FF3B30] bg-[#FF3B30]/10",
    rejected: "text-[#FF3B30] bg-[#FF3B30]/10", suspended: "text-[#FF3B30] bg-[#FF3B30]/10",
    disconnected: "text-gray-400 bg-white/5", closed: "text-gray-400 bg-white/5",
  };
  return (
    <span className={`inline-flex px-2 py-0.5 rounded text-[11px] uppercase tracking-wider font-medium ${map[status] || "text-gray-400 bg-white/5"}`}>
      {status || "—"}
    </span>
  );
};

export const PageHeader = ({ title, sub, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div>
      <h1 className="font-display text-2xl text-white">{title}</h1>
      {sub && <p className="text-sm text-gray-500 mt-1">{sub}</p>}
    </div>
    {children}
  </div>
);

export const SkeletonGrid = ({ n = 6 }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
    {Array.from({ length: n }).map((_, i) => <div key={i} className="skeleton h-24" />)}
  </div>
);

export const EmptyState = ({ title, sub, action }) => (
  <div className="card-dark p-12 text-center" data-testid="empty-state">
    <p className="text-gray-300">{title}</p>
    <p className="text-sm text-gray-500 mt-2">{sub}</p>
    {action}
  </div>
);

export const Table = ({ headers, children, testId }) => (
  <div className="card-dark overflow-x-auto" data-testid={testId}>
    <table className="w-full text-sm min-w-[640px]">
      <thead>
        <tr className="border-b border-white/10">
          {headers.map((h) => <th key={h} className="text-left px-4 py-3 label-xs whitespace-nowrap">{h}</th>)}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);

export const Td = ({ children, className = "" }) => <td className={`px-4 py-3 text-gray-300 whitespace-nowrap ${className}`}>{children}</td>;
